export let CaretGravityType = /*#__PURE__*/function (CaretGravityType) {
  CaretGravityType[CaretGravityType["Forward"] = 0] = "Forward";
  CaretGravityType[CaretGravityType["Backward"] = 1] = "Backward";
  return CaretGravityType;
}({});
export let StateName = /*#__PURE__*/function (StateName) {
  StateName["literal"] = "literal";
  StateName["numeric"] = "numeric";
  StateName["alphaNumeric"] = "alphaNumeric";
  return StateName;
}({});
//# sourceMappingURL=types.js.map